<template>
  <div v-if="show" class="dialog-overlay" @click.self="fechar">
    <div class="dialog-container">
      <div class="dialog-header">
        <h3 class="dialog-title">{{ titulo }}</h3>
        <button @click="fechar" class="dialog-close">×</button>
      </div>
      <div class="dialog-body">
        <p v-html="mensagem"></p>
      </div>
      <div class="dialog-footer">
        <button v-if="tipo === 'confirm'" @click="cancelar" class="btn-cancel">Cancelar</button>
        <button @click="confirmar" class="btn-confirm">{{ botaoTexto }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    titulo: {
      type: String,
      default: 'Atenção'
    },
    mensagem: {
      type: String,
      required: true
    },
    tipo: {
      type: String,
      default: 'alert', // 'alert' ou 'confirm'
      validator: (value) => ['alert', 'confirm'].includes(value)
    },
    botaoTexto: {
      type: String,
      default: 'OK'
    }
  },
  methods: {
    fechar() {
      this.$emit('close')
    },
    confirmar() {
      this.$emit('confirm')
      if (this.tipo === 'alert') {
        this.fechar()
      }
    },
    cancelar() {
      this.$emit('cancel')
      this.fechar()
    }
  }
}
</script>

<style scoped>
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 20px;
}

.dialog-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  width: 100%;
  max-height: 90vh;
  overflow: auto;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.dialog-title {
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  margin: 0;
}

.dialog-close {
  background: transparent;
  border: none;
  font-size: 28px;
  color: #6b7280;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s;
}

.dialog-close:hover {
  background: #f3f4f6;
  color: #111827;
}

.dialog-body {
  padding: 24px;
}

.dialog-body p {
  margin: 0;
  color: #4b5563;
  font-size: 16px;
  line-height: 1.6;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid #e5e7eb;
}

.btn-cancel {
  background: transparent;
  color: #6b7280;
  border: 1px solid #d1d5db;
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-cancel:hover {
  background: #f9fafb;
  border-color: #9ca3af;
}

.btn-confirm {
  background: #34894d;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-confirm:hover {
  background: #2d7a42;
}
</style>

